import React from 'react'
import { Link as RouterLink } from 'react-router-dom'

import { List, ListItemButton, ListItemText, Paper, Typography } from '@mui/material'

import { SEO_LANDING_NAV } from 'src/seo/landingPaths'

export const SeoIntroLinks: React.FC = () => {
  return (
    <Paper
      elevation={0}
      sx={{
        border: '1px solid',
        borderColor: 'rgba(0, 0, 0, 0.08)',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
        bgcolor: '#fafcfd',
        borderRadius: 2,
        p: { xs: 2.25, sm: 3 }
      }}
    >
      <Typography
        variant='overline'
        sx={{
          display: 'block',
          letterSpacing: '0.1em',
          fontWeight: 700,
          color: '#eca10c',
          mb: 1
        }}
      >
        Довідкові матеріали
      </Typography>
      <Typography
        variant='h6'
        component='p'
        sx={{
          fontWeight: 600,
          fontSize: { xs: '1rem', sm: '1.1rem' },
          lineHeight: 1.45,
          mb: 2.5,
          color: 'text.primary'
        }}
      >
        Комплектуючі для вентиляції та кондиціонування повітря, каталог решіток і дифузорів,
        повітропроводи та замовлення в Києві — оберіть тему:
      </Typography>
      <List disablePadding sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        {SEO_LANDING_NAV.map((item) => (
          <ListItemButton
            key={item.path}
            component={RouterLink}
            to={item.path}
            sx={{
              borderRadius: 1.5,
              py: 1.35,
              px: 2,
              border: '1px solid',
              borderColor: 'rgba(21, 150, 192, 0.22)',
              bgcolor: '#fff',
              alignItems: 'flex-start',
              transition: 'background-color 0.2s ease, border-color 0.2s ease',
              '&:hover': {
                bgcolor: 'rgba(35, 152, 219, 0.07)',
                borderColor: 'rgba(21, 150, 192, 0.45)'
              }
            }}
          >
            <ListItemText
              primary={item.label}
              primaryTypographyProps={{
                variant: 'body2',
                sx: {
                  fontWeight: 500,
                  lineHeight: 1.5,
                  color: 'text.primary'
                }
              }}
            />
          </ListItemButton>
        ))}
      </List>
    </Paper>
  )
}
